export default "__VITE_ASSET__B7l49_TU__"